<template>
  <modal 
    :show.sync="show"
    modal-classes="modal-lg"
    @close="close">
    <div 
      slot="base-content" 
      class="card card-plain mb-0">
      <div class="modal-header justify-content-center">
        <button 
          type="button" 
          class="btn-sm close text-dark" 
          data-dismiss="modal" 
          aria-hidden="true"
          @click="close">
          <i class="now-ui-icons ui-1_simple-remove"/>
        </button>
        <div class="header header-primary text-center">
          <h4 class="font-weight-bold m-0">Instructions</h4>
        </div>
      </div>
      <div class="modal-body pt-0">
        <div 
          v-if="data"
          class="row">
          <div class="col-12">
            <h4 class="text-center mt-2">{{ data.name }}</h4>
          </div>
          <div class="col-12">
            <collapse
              :active-index="index">
              <collapse-item 
                v-for="(section, index) in data.sections"
                :key="index"
                :title="section.name">
                <template v-slot:title>
                  {{ section.name }}
                </template>
                <template v-slot:icon>
                  <i class="bx bx-plus mr-1" />
                  <i class="bx bx-minus mr-1" />
                </template>
                <div v-html="section.text" />
              </collapse-item>
            </collapse>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-end">
        <n-button
          type="success"
          @click.native="print">
          Print
        </n-button>
      </div>
    </div>
  </modal>
</template>
<script>
  import axios from 'axios';
  import moment from 'moment';
  import { mapState, mapMutations } from 'vuex';
  import { Button, Collapse, CollapseItem, Modal } from '@/components';

  export default {
    components: {
      [Button.name]: Button,
      Collapse,
      CollapseItem,
      Modal
    },
    props: {
      open: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        show: false,
        index: 0
      };
    },
    computed: {
      ...mapState([
        'options'
      ])
    },
    watch: {
      open() {
        this.show = this.open;
        this.index = 0;
      }
    },
    methods: {
      close() {
        this.$emit('close');
      },
      print() {
        window.print();
      }
    }
  }
</script>
<style lang='scss' scoped>
  ::v-deep .card-collapse {
    .card {
      margin-bottom: 0;

      .card-header {
        a {
          .bx {
            float: left;
          }
          .bx-plus {
            display: inline-block;
            top: 5px;
          }
          .bx-minus {
            display: none;
          }
        }
        a[aria-expanded="true"] {
          .bx {
            float: left;
          }
          .bx-plus {
            display: none;
          }
          .bx-minus {
            display: inline-block;
            top: 5px;
          }
        }
      }
    }
  }
  p {
    color: #2c2c2c;
    font-size: 1.1em;
  }
</style>
